import { useTranslation } from 'react-i18next'
import { PageTitle } from '../components/common/PageTitle/PageTitle'
import { ReportingTableContainer } from '@/features/Reporting/components/ReportsTableContainer/ReportsTableContainer'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { Navigate } from '@tanstack/react-router'

export default function Reporting() {
    const { t } = useTranslation('translations')

    return (
        <div className="grid h-full grid-rows-[auto_1fr]">
            <PageTitle
                label={t('sidebar_menu.reporting')}
                labelTestId="page-title-reporting"
            />
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>
            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <div className="h-full overflow-hidden p-6">
                    <ReportingTableContainer />
                </div>
            </RoleRestrictedContent>
        </div>
    )
}
